import React from 'react';

import styles from './root-display-position-controls.scss';

function handleChange(onChange) {
  return (element) => {
    onChange(element.target.value);
  };
}

export default function RootDisplayPositionControls(props) {
  const {value, onChange} = props;

  return (
    <div className={styles.wrapper}>
      <span>
        Stick to:
      </span>

      <label>
        <input
          type='radio'
          name='root-display-position'
          value='top'
          checked={value === 'top'}
          onChange={handleChange(onChange)}
        />
        Top
      </label>

      <label>
        <input
          type='radio'
          name='root-display-position'
          value='bottom'
          checked={value === 'bottom'}
          onChange={handleChange(onChange)}
        />
        Bottom
      </label>
    </div>
  );
}

RootDisplayPositionControls.propTypes = {
  value: React.PropTypes.oneOf(['top', 'bottom']).isRequired,
  onChange: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/components/root-display-position-controls.jsx